import axios from 'axios';
import { sanatiseStr } from 'utils';

const BaseUrl = window.location.origin;

// Create Axios Instance
export const axiosInstance = axios.create({
    baseURL: BaseUrl,
});

// const responseHandler = response => {
//     let res = response.toString()
//     res = sanatiseStr(res);
//     return JSON.parse(res);
// };

// if(process.env.NODE_ENV !== "development"){
//     axiosInstance.interceptors.response.use((response => responseHandler(response)));
// }
